import React, { useState } from 'react';
import './StarRating.css';

export interface StarRatingProps {
  rating: number;
  totalRatings: number;
  size?: 'small' | 'medium' | 'large';
  showCount?: boolean;
  interactive?: boolean;
  onRatingChange?: (rating: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  totalRatings,
  size = 'medium',
  showCount = true,
  interactive = false,
  onRatingChange
}) => {
  const [hoverRating, setHoverRating] = useState<number | null>(null);

  const handleStarClick = (index: number) => {
    if (interactive && onRatingChange) {
      onRatingChange(index + 1);
    }
  };

  const handleStarHover = (index: number) => {
    if (interactive) {
      setHoverRating(index + 1);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoverRating(null);
    }
  };

  const displayRating = hoverRating !== null ? hoverRating : rating;

  return (
    <div 
      className={`star-rating ${size}`}
      onMouseLeave={handleMouseLeave}
    >
      <div className="stars">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= displayRating;
          const isHalfFilled = !isFilled && starValue - 0.5 <= displayRating;

          return (
            <span
              key={index}
              className={`star ${interactive ? 'interactive' : ''}`}
              onClick={() => handleStarClick(index)}
              onMouseEnter={() => handleStarHover(index)}
            >
              {isHalfFilled ? (
                <>
                  <span className="star-fill" style={{ width: '50%' }}>★</span>
                  <span className="star-outline">☆</span>
                </>
              ) : (
                <>
                  <span className="star-fill" style={{ width: isFilled ? '100%' : '0%' }}>★</span>
                  <span className="star-outline">☆</span>
                </>
              )}
            </span>
          );
        })}
      </div>
      {showCount && totalRatings > 0 && (
        <span className="rating-count">({totalRatings})</span>
      )}
    </div>
  );
};

export default StarRating; 